export default __webpack_public_path__ + "static/media/Roboki@2x.679e4502.png";